module.exports = __webpack_public_path__ + "img/card5.266abd47.jpg";